import { Pipe, PipeTransform } from "@angular/core";
import { AnyAbility } from "@casl/ability";
import { AblePurePipe } from "@casl/angular";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Pipe({
    name: "isNotAblePure",
    standalone: false
})
export class IsNotAblePurePipe<T extends AnyAbility>
  extends AblePurePipe<T>
  implements PipeTransform
{
  transform(...args: Parameters<T["can"]>): Observable<boolean> {
    if (args.filter((s) => s).length < 1) {
      return of(false);
    }
    return super.transform(...args).pipe(map((x) => !x));
  }
}
